module.exports = __webpack_public_path__ + "img/czqy1.bbc7f723.png";